import { useIntersectionObserver, useThrottleFn } from '@vueuse/core';
import { onBeforeUnmount, onMounted, computed, defineComponent, ref } from 'vue';
import { SlideShowBottomBar, SlideShowTopBar, useSlideShow, EBlockWidth, RowType, } from '@getaccept/editor-lib-new';
import EditorCell from './EditorCell.vue';
export default defineComponent({
    name: 'EditorRowSlideShow',
    components: {
        EditorCell,
        SlideShowBottomBar,
        SlideShowTopBar,
    },
    props: {
        cells: {
            type: Array,
            default: () => [],
        },
        blockWidthClass: { type: String, default: null },
        rowType: { type: String, default: null },
        isBlockToggled: { type: Boolean, default: false },
        pageWidth: { type: Number, default: null },
        rowId: { type: String, default: null },
        isPreview: { type: Boolean },
    },
    emits: ['observe-node-visibility', 'fetch-new-image'],
    setup(props) {
        const slideshowWrapper = ref(null);
        const slideshowBottom = ref(null);
        const { current, transitionName, isGridView, isSticky, slides, gridSlides, observerOptions, slide, handleToggleGridView, handleClick, currentSlide, handleKeyDown, handleDragStart, handleDragEnd, isLightboxView, handleToggleLightBoxView, handleShowToolbar, showToolbar, lightboxContainerRef, handleResize, removeLightBoxQuery, lightboxRoute, isSmallScreen, } = useSlideShow(props);
        const rowTypeClass = computed(() => { var _a; return `row-type-${(_a = props.rowType) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`; });
        const isMouseOver = ref(false);
        const isVisible = ref(false);
        const isParentFirstChild = (index) => index === 0;
        const isParentLastChild = (index) => index === props.cells.length - 1;
        const handleMouseOver = () => {
            isMouseOver.value = true;
        };
        useIntersectionObserver(slideshowWrapper, ([{ isIntersecting }]) => {
            handleVisibility(isIntersecting);
        }, {
            threshold: 0.7,
        });
        const slideshowBottomObserveHandler = useThrottleFn(([{ isIntersecting }]) => {
            observerOptions.value.callback(isIntersecting);
        }, observerOptions.value.throttle, false, observerOptions.value.leading);
        useIntersectionObserver(slideshowBottom, slideshowBottomObserveHandler, {
            threshold: observerOptions.value.threshold,
        });
        const handleVisibility = (visible) => {
            isVisible.value = visible;
        };
        const handleKeyBoardNavigation = (event) => {
            if (isLightboxView.value || isVisible.value) {
                handleKeyDown(event);
            }
        };
        const handleMouseOut = () => {
            isMouseOver.value = false;
        };
        onMounted(() => {
            window.visualViewport.addEventListener('resize', handleResize);
            window.addEventListener('keydown', handleKeyBoardNavigation);
            removeLightBoxQuery();
        });
        onBeforeUnmount(() => {
            window.visualViewport.removeEventListener('resize', handleResize);
            window.removeEventListener('keydown', handleKeyBoardNavigation);
        });
        return {
            rowTypeClass,
            current,
            transitionName,
            slides,
            RowType,
            lightboxRoute,
            currentSlide,
            handleClick,
            isParentFirstChild,
            isParentLastChild,
            handleToggleGridView,
            EBlockWidth,
            slide,
            isGridView,
            handleDragEnd,
            handleDragStart,
            observerOptions,
            isSticky,
            gridSlides,
            handleMouseOver,
            handleMouseOut,
            isMouseOver,
            isLightboxView,
            handleToggleLightBoxView,
            handleShowToolbar,
            showToolbar,
            lightboxContainerRef,
            isSmallScreen,
            handleVisibility,
            isVisible,
            slideshowWrapper,
            slideshowBottom,
        };
    },
});
